import Route from '@ember/routing/route';

export default class DemosRoute extends Route {
}